import { checkPassword, tr } from 'mmfintech-commons'
import CheckBullet from './CheckBullet'
import './PasswordTerms.scss'

interface Props {
  password?: string
  differ?: boolean
  differLogic?: boolean
}

function PasswordTerms({ password = '', differ = null, differLogic = null }: Props) {
  const { digit, letter, special, minLength } = checkPassword(password?.trim() || '').terms

  return (
    <div className='password-terms'>
      <CheckBullet
        empty={!password.length}
        valid={digit}
        caption={tr('VALIDATION.PASSWORD.TERMS.DIGIT', 'Оne digit')}
      />
      <CheckBullet
        empty={!password.length}
        valid={letter}
        caption={tr('VALIDATION.PASSWORD.TERMS.LETTER', 'Оne letter')}
      />
      <CheckBullet
        empty={!password.length}
        valid={special}
        caption={tr('VALIDATION.PASSWORD.TERMS.SPECIAL_CHAR', 'Оne special character')}
      />
      <CheckBullet
        empty={!password.length}
        valid={minLength}
        caption={tr('VALIDATION.PASSWORD.TERMS.MIN_LENGTH', 'Minimum 8 (eight) characters')}
      />
      {differ && (
        <CheckBullet
          empty={!password.length}
          valid={differLogic}
          caption={tr('VALIDATION.PASSWORD.TERMS.DIFFER', 'New password should be different from the old one')}
        />
      )}
    </div>
  )
}

export default PasswordTerms
